module.exports = __webpack_public_path__ + "img/icon-add.f2aa15da.svg";